<h2 mat-dialog-title>Vista previa del catálogo</h2>

<mat-dialog-content class="preview-content">
  <div class="preview-state" *ngIf="loading">
    <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
    <p>Generando vista previa...</p>
  </div>

  <div class="preview-state" *ngIf="!loading && error">
    <mat-icon>error_outline</mat-icon>
    <p>{{ error }}</p>
  </div>

  <iframe
    *ngIf="!loading && !error"
    class="preview-frame"
    [srcdoc]="safeHtml"
    sandbox="allow-same-origin"
    title="preview"
  ></iframe>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">Cerrar</button>
</mat-dialog-actions>
